import { render, staticRenderFns } from "./bulma_login.vue?vue&type=template&id=7c8ff8a0&scoped=true&lang=html"
import script from "./bulma_login.vue?vue&type=script&lang=js"
export * from "./bulma_login.vue?vue&type=script&lang=js"
import style0 from "./bulma_login.vue?vue&type=style&index=0&id=7c8ff8a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8ff8a0",
  null
  
)

export default component.exports